const darkLightPageStyles = {
    light: {
        bgColor: "#fff",
        pageTitleColor: "color2",
    },
    dark: {
        bgColor: "transparent",
        pageTitleColor: "color1",
    },
}

export default darkLightPageStyles
